import React, { useCallback } from 'react';
import { MessageRendererProps } from '@pubnub/react-chat-components';
import clsx from 'clsx';
import dayjs from 'dayjs';
import UserIcon from 'assets/svg/User';

export default function useMessageRenderer(props: {
  ownUsername: string;
  anotherUsername?: string;
  lastRead?: number;
}) {
  return useCallback(
    (e: MessageRendererProps) => {
      const oneSecond = 1000;
      const isRead = !!props.lastRead && e.isOwn && +e.message.timetoken <= (+props.lastRead + oneSecond) * 10000;

      return (
        <div
          className={clsx('flex flex-col w-full gap-3 py-2 px-2', !e.isOwn && 'bg-red-50 rounded-lg')}
          key={e.message.uuid}
        >
          <div className={clsx('flex w-full gap-4', e.isOwn ? 'justify-end' : 'justify-start')}>
            <p className={'font-semibold text-sm text-brand-black rounded-lg break-all'}>
              <UserIcon size={24} className={'inline mr-1'} />{' '}
              {e.isOwn
                ? e.user?.name || props.ownUsername || 'You'
                : e.user?.name || props.anotherUsername || e.message.uuid}
            </p>

            <p className={'font-normal text-xs/5 text-brand-purple-gray2 break-all max-w-full'}>
              {dayjs((e.message.message as any)?.createdAt).format('L LT')}{' '}
              {!e.isOwn ? '' : <b className={isRead ? 'text-sky-500' : ''}>{` ${isRead ? '✓✓' : '✓'}`}</b>}
            </p>
          </div>

          <p
            className={clsx(
              'text-sm text-brand-black break-words whitespace-pre-wrap bg-white w-fit px-4 py-3 rounded-lg font-medium',
              e.isOwn && 'text-right ml-auto',
            )}
          >
            {e.editedText || (e.message.message as any)?.text}
          </p>
        </div>
      );
    },
    [props.ownUsername, props.anotherUsername, props.lastRead],
  );
}
